<template>
    <v-container fluid class="pa-0" style="position: relative;">
    <!-- Formulaire -->
    <v-card v-show="!dialogSign" fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title >
            <span>Assignation / Mouvement</span>
            <v-spacer></v-spacer>
            <v-chip outlined color="secondary" v-if="item.ass_updated_at">
                    <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.ass_updated_at).format('DD MMMM YYYY') }}
            </v-chip>
        </v-card-title>
        <v-form ref="form" v-model="validForm" lazy-validation>
        
        <!-- Sites -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <AutocompleteMulti  :title="'Site d\'origine'" :ressource="'sites'" :listObject.sync="item.ass_sit_id_old" :listParent.sync="autoCompleteSource.siteOldList"
                :fields="{ 
                    index: 'sit_id', text:'sit_name,sit_address,sit_town', autofocus: true, dense: true,
                    search:'sit_name', multiSelect:false, prefetch: true, params:'' 
                }"/>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <AutocompleteMulti  :title="'Site de destination'" :ressource="'sites'" :listObject.sync="item.ass_sit_id" :listParent.sync="autoCompleteSource.siteNewList"
                :fields="{ 
                    index: 'sit_id', text:'sit_name,sit_address,sit_town', autofocus: true, dense: true,
                    search:'sit_name', multiSelect:false, prefetch: true, params:'' 
                }"/>
            </v-col>
        </v-row>

        <!-- Type et Statut -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['ASH']" item-text="typ_name" item-value="typ_id" v-model="item.ass_typ_id" label="Type" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <!--<v-text-field outlined dense class="rounded-lg" label="Statut (ass_sta_id)" v-model="item.ass_sta_id" maxlength="6" placeholder="GEN01"></v-text-field>-->
            </v-col>
        </v-row>

        <!-- Véhicule et Chauffeur -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <AutocompleteMulti v-if="!loading.fetchData"
                    :title="'Véhicule'" :ressource="'equipments'" ref="autoCarrier"
                    :listObject.sync="item.ass_equ_id_vehicle" :listParent.sync="autoCompleteSource.listEquipmentItemSource" 
                    :notfoundClick="createAndSelectEquipment"
                    :fields="{ 
                        index: 'equ_id', text:'equ_name,equ_serial', autofocus: true, dense: true, resultlimit: 25,
                        search:'equ_name', multiSelect:false, prefetch: true, params:'', notfound: 'Créer le véhicule [Nom Immatriculation]'
                }"></AutocompleteMulti>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <AutocompleteMulti 
                    :title="'Chauffeur'" :ressource="'users'" ref="autoDriver"
                    :listObject.sync="item.ass_usr_id_driver" :listParent.sync="autoCompleteSource.userList"
                    :notfoundClick="createAndSelectDriver"
                    :fields="{ 
                        index: 'id', text:'middleName', autofocus: true, dense: true, resultlimit: 25,
                        search:'usr_middleName', multiSelect:false, prefetch: true, params:'usr_role=DRIVER&', notfound: '-- Créer le chauffeur --'
                    }"/>
            </v-col>
        </v-row>

        <!-- Dates de départ -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Date de départ" v-model="item.ass_departure_date" type="date"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pl-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Heure de départ" v-model="item.ass_departure_time" type="time"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pl-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['ASR']" item-text="typ_name" item-value="typ_id" v-model="item.ass_typ_id_dep" label="Départ" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="2" class="pl-2">
                <v-checkbox v-model="item.ass_dep_empty" true-value="1" false-value="0" :label="'Camion vide'"></v-checkbox>
            </v-col>
        </v-row>

        <!-- Dates d'arrivée -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Date d'arrivée" v-model="item.ass_arrival_date" type="date"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pl-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Heure d'arrivée" v-model="item.ass_arrival_time" type="time"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pl-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['ASR']" item-text="typ_name" item-value="typ_id" v-model="item.ass_typ_id_arr" label="Départ" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="2" class="pl-2">
                <v-checkbox v-model="item.ass_arr_empty" true-value="1" false-value="0" :label="'Camion vide'"></v-checkbox>
            </v-col>
        </v-row>
        <!-- Animaux -->
        <v-row no-gutters>
            <v-col cols="12">
                <AutocompleteMulti v-if="!loading.fetchData"
                        :title="'Animaux'" :ressource="'livestocks'" :disabled="loading.fetchData"
                        :listObject.sync="item._pivot.livestocks" :listParent.sync="autoCompleteSource.livestockList" 
                        :fields="{
                            index: 'lst_id', text:'lst_name,lst_tag', autofocus: false, deletablechips: true,
                            search:'lst_name', preprendIcon:'', multiSelect:true, prefetch: true, params:'' 
                    }"></AutocompleteMulti>
                <v-alert v-if="notFoundTagsUnique.length > 0" border="right" colored-border type="error" elevation="2" >
                    Tag non trouvés : 
                    <v-chip v-for="(item,i) in notFoundTagsUnique" :key="i" class="ma-1" small color="primary">{{ item }}</v-chip>
                </v-alert>
                <v-textarea outlined dense class="rounded-lg" label="Animaux" v-model="lstText" rows="3"></v-textarea>
            </v-col>
        </v-row>
        <!-- Raison du mouvement -->
        <v-row no-gutters>
            <v-col cols="9" class="pr-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Raison du mouvement" v-model="item.ass_customfields.ass_reason"></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field outlined dense class="rounded-lg" label="Nombre de mort (transport)" type="numeric" v-model="item.ass_customfields.ass_death"></v-text-field>
            </v-col>
        </v-row>

        <!-- Champs personnalisés -->
        <v-row no-gutters>
            <v-col cols="12">
                <v-textarea outlined dense class="rounded-lg" label="Remarques" v-model="item.ass_customfields.observation" rows="3"></v-textarea>
            </v-col>
        </v-row>

        </v-form>
        <v-card-actions>
            <v-btn class="rounded-xl" large color="red" v-if="item.uid" @click="deleteItem(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="(loading.fetchData || !validForm)">Enregistrer</v-btn>
            <v-btn class="rounded-xl" large color="primary" href="/#/assignments/">Retour</v-btn>
        </v-card-actions>
    </v-card>
    <!-- Modal signature -->
        <v-card v-if="dialogSign" style="background-color: white; position: absolute; top:0px; width: 100%; height: 100%;">
            <v-toolbar dark color="primary" dense text>
                <v-toolbar-title class="white--text">Signature {{ (dialogSign==1) ? 'Détenteur de départ' : 'Détenteur d\’arrivée' }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="d-flex justify-center align-center" style="min-height: 400px;">
                <VueSignaturePad width="500px" height="400px" ref="signaturePad" style="border: 1px solid red;" />
            </v-card-text>
            <v-card-actions>
                <v-toolbar color="transparent" bottom height="48px">
                    <v-spacer></v-spacer>
                    <v-btn color="red" v-show="dialogSign==1" @click="saveSignature()"><v-icon title="Suivant">mdi-next</v-icon>Suivant</v-btn>
                    <v-btn color="red" v-show="dialogSign==2" @click="saveSignature()"><v-icon title="Terminer">mdi-next</v-icon>Terminer</v-btn>
                </v-toolbar>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
    
<script>
import { mapState, mapWritableState, mapActions } from 'pinia'
import { useAssignmentStore } from '@/stores/assignment'
import { useLivestockStore } from '@/stores/livestock'
import { useUserStore } from '@/stores/user'
import { useEquipmentStore } from '@/stores/equipment'

import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

export default {
    name: 'assignments-edit',
    components: { AutocompleteMulti },
    computed: {
        ...mapWritableState(useAssignmentStore, {item: 'item' }),
        ...mapState(useLivestockStore, {itemLivestockList: 'itemList' }),
        ...mapState(useUserStore, {itemUser: 'item' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapWritableState(useLivestockStore, {correctedTag: 'correctedTag' }),
        ...mapWritableState(useEquipmentStore, {itemEquipment: 'item' }),
    },
    watch: {
        // Ajouter ce watcher pour le debounce
        lstText(newVal) {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }
            this.debounceTimer = setTimeout(() => {
                if(newVal.length > 10){
                    this.formatLivestocks(newVal)
                }
            }, 1000)
        }
    },
    data: function () {
        return {
            loading: { fetchData: true },
            validForm: true,
            requiredRules: [ 
                v => !!v || 'Le champ doit être renseigné', 
            ],
            autoCompleteSource: { userList: [], siteOldList: [], siteNewList: [], livestockList: [], listEquipmentItemSource: [] },
            lstText: '',
            notFoundTagsUnique: [],
            dialogSign: 0,
        }
    },
    async mounted () {
        await this.fetchLivestockItem()
        const assId = (this.itemId) ? this.itemId : this.$route.params.ass_id
        if (assId && parseInt(assId) > 0) {
            await this.fetchItem(assId, '?include=livestocks' )
        } else {
           this.initItem()
           this.item.ass_departure_date = this.$date().format('YYYY-MM-DD')
           this.item.ass_arrival_date = this.$date().format('YYYY-MM-DD')
           this.item.ass_departure_time = this.$date().format('HH:mm')
           this.item.ass_arrival_time = this.$date().add(1, 'hour').format('HH:mm')
        }
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useAssignmentStore, {fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', deleteItem: 'deleteItem', initItem: 'RESET_ITEM'}),
        ...mapActions(useLivestockStore, {fetchLivestockItem: 'fetchItem', initLivestockItem: 'RESET_ITEM', formatTag: 'formatTag'}),
        ...mapActions(useUserStore, {fetchUser: 'fetchItem', storeUserItem: 'storeItem', initUserItem: 'RESET_ITEM'}),
        ...mapActions(useEquipmentStore, {storeEquipmentItem: 'storeItem', initEquipmentItem: 'RESET_ITEM'}),
        async saveItem() {
            this.$root.$confirm(
                'Terminer', 
                'Confirmer : terminer l\'action ? <br /> Vous avez la possibilité de signer', { color: 'primary', width: 400 },
                [
                    { color: 'blue darken-1', value: 'sign', text: 'Signer', icon: 'mdi-signature-freehand' },    
                    { color: 'success darken-1', value: true, text: 'Terminer' },
                    { color: 'grey', value: false, text: 'Annuler' }
                ])
                .then((confirm) => {
                    if( confirm == 'sign' ){
                        this.dialogSign = 1
                    } else if( confirm === true ){
                        this.execSaveItem()
                    }
                })
        },
        async saveSignature(){
            const { isEmpty, data } = await this.$refs.signaturePad.saveSignature('image/svg+xml');
            if( this.dialogSign == 1 ){
                this.item.ass_sign_worker = data
            } else if( this.dialogSign == 2){
                this.item.ass_sign_customer = data
                this.execSaveItem()
            }
            if( !isEmpty ){
                this.dialogSign = (this.dialogSign == 1 ) ? 2 : 0
            }

            this.$refs.signaturePad.clearSignature()
        },
        async execSaveItem () {
            await this.$refs.form.validate()
            if( this.validForm ){
                // Enregistrement du formulaire
                this.loading.fetchData = true
                if( parseInt( this.item.ass_id ) > 0 ){
                    await this.updateItem()
                } else {
                    await this.storeItem()
                }
                this.$router.push({ path: '/assignments' })
            }
        },
        async formatLivestocks(newVal){
            this.formatTag(newVal)

            // Création d'un Set pour une recherche rapide (O(1))
            const assignSet = new Set(this.correctedTag);
            const sourceTagsSet = new Set(this.itemLivestockList.map(item => item.lst_tag));
            // 1. Les lst_id du tableau 'source' dont le lst_tag est dans 'assign'
            const foundIds = this.itemLivestockList.filter(item => assignSet.has(item.lst_tag)).map(item => item.lst_id);

            this.item._pivot.livestocks.splice(0)
            this.item._pivot.livestocks.push(...foundIds) // Résultat : [1, 2, 3]

            // 2. Les tags de 'assign' qui ne sont PAS dans 'source'
            const notFoundTags = this.correctedTag.filter(tag => !sourceTagsSet.has(tag));

            // Si vous voulez une liste unique (sans doublons) :
            this.notFoundTagsUnique = [...new Set(notFoundTags)];
            this.lstText = ''
        },
        async createAndSelectDriver(searchText) {
            if (!searchText || !searchText.trim()) return
            
            const parts = searchText.trim().split(/\s+/)
            const lastName = parts[0] || ''
            const firstName = parts.slice(1).join(' ') || ''

            // Générer un email aléatoire
            const randomStr = Math.random().toString(36).substring(2, 10)
            const randomEmail = `${randomStr}@lafermedespuits.fr`

            this.initUserItem()
            this.itemUser.middleName = searchText
            this.itemUser.firstName  = firstName
            this.itemUser.lastName   = lastName
            this.itemUser.role       = 'DRIVER'
            this.itemUser.email      = randomEmail
            this.itemUser.username   = randomEmail
            try {
                await this.storeUserItem()
                // Ajouter le nouvel utilisateur à la liste et le sélectionner
                //this.autoCompleteSource.userList = [...this.autoCompleteSource.userList, this.itemUser]
                this.$nextTick(async () => {
                    this.$refs.autoDriver.refreshList(this.itemUser.id)
                    this.item.ass_usr_id_driver = this.itemUser.id
                })
            } catch (error) {
                console.error('Erreur création chauffeur:', error)
            }
        },
        async createAndSelectEquipment(searchText) {
            if (!searchText || !searchText.trim()) return
            
            const parts = searchText.trim().split(/\s+/)
            const name = parts[0] || ''
            const serial = parts.slice(1).join(' ') || ''

            this.initEquipmentItem()
            this.itemEquipment.equ_name = name
            this.itemEquipment.equ_serial  = serial
            try {
                await this.storeEquipmentItem()
                // Ajouter le nouvel utilisateur à la liste et le sélectionner
                this.$nextTick(async () => {
                    this.$refs.autoCarrier.refreshList(this.itemEquipment.equ_id)
                    this.item.ass_equ_id_vehicle = this.itemEquipment.equ_id
                })
            } catch (error) {
                console.error('Erreur création chauffeur:', error)
            }
        },
    }
}
</script>